module.exports = __webpack_public_path__ + "img/reporting_posts_reaction.ba912fe0.svg";